import React from 'react';
import { useTranslation } from 'react-i18next';
import Hero from '../components/Hero';
import Projects from '../components/Projects';
import Methodology from '../components/Methodology';
import Contact from '../components/Contact';

const HomePage: React.FC = () => {
  const { t } = useTranslation(['common', 'portfolio']);
  const personalInfo = t('personalInfo', { ns: 'portfolio', returnObjects: true }) as any;
  const projects = t('projects', { ns: 'portfolio', returnObjects: true }) as any;
  const serviceCards = t('serviceCards', { ns: 'portfolio', returnObjects: true }) as any;
  const social = t('social', { ns: 'portfolio', returnObjects: true }) as any;

  return (
    <>
      <Hero personalInfo={personalInfo} serviceCards={serviceCards} />
      <Projects projects={projects} />
      <Methodology />
      <Contact personalInfo={personalInfo} social={social} />
    </>
  );
};

export default HomePage;
